export default {
      id: "instagram-usage",
      viewBox: "0 0 26 25",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#instagram",
      toString: function () {
        return this.url;
      }
    }